'use strict';

HSupportLink.$inject = [];

function HSupportLink() {
    const self = this;

    self.redirectToSupport = () => {
        Utils.redirectToCommunitySupport(self.openNewTab);
    };
}

angular
    .module('harriApp')
    .directive('hSupportLink', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            controller: HSupportLink,
            controllerAs: '$ctrl',
            bindToController: {
                openNewTab: '<'
            },
            templateUrl: '../hmodules/harri-main/directives/h-support-link/h-support-link.directive.ng.html'
        }
    });